// @ts-nocheck

import { reduce as _reduce } from 'lodash';

import { BasketModes, BasketStatuses, BasketItemStatuses } from '../../../types/basket';
import { basket as BasketUtils } from '../../../utils';
import recomputeBasketStateForOperations from '../utils/recomputeBasketStateForOperations';

const { formatStake } = BasketUtils;

const { checkIfItemCanBeAdded, getMode, generateSystems } = BasketUtils;

const addBetBuilderItem = (state, action, { entities }) => {
  const { mode, status, items, stake, defaultStake, freebets, selectedFreebetId } = state;

  let nextStake = stake || defaultStake;
  const { matchId, selectionItems, source, value, ts } = action.payload;
  const { matches, bets } = entities;
  const match = matches[matchId];

  const canBeAdded = selectionItems.reduce((result, item) => {
    const bet = bets[item.betId];

    return result && checkIfItemCanBeAdded({ match, bet });
  }, true);

  if (canBeAdded) {
    // NOTE: if basket is validated we have to start from a cleaned object items
    let nextItems = {};
    if (status !== BasketStatuses.VALIDATED && status !== BasketStatuses.WAITING) {
      nextItems = _reduce(
        items,
        (finalItems, item, key) => {
          if (
            item.status !== BasketItemStatuses.VALIDATED &&
            item.status !== BasketItemStatuses.WAITING &&
            item.status !== BasketItemStatuses.REJECTED
          ) {
            return {
              ...finalItems,
              [key]: {
                ...item,
                status: BasketItemStatuses.OK,
                betslipId: undefined,
                error: undefined,
                additionalMessage: undefined,
              },
            };
          }
          return finalItems;
        },
        {},
      );
    }

    // - Allow multiple betbuilder on same match
    // - U is used as separator instead of -
    //   because of src/store/apiMiddleware.js:L39 and src/store/apiMiddleware.js:L50
    const uniqId = `${matchId}U${ts}`;

    if (source) {
      // edit item case, we remove old item to replace uniq id https://redmine.winamax.fr/issues/123632
      delete nextItems[source];
    }
    // add item
    nextItems[uniqId] = {
      betbuilder: true,
      status: BasketItemStatuses.OK,
      sportId: match.sportId,
      matchId,
      oddId: uniqId,
      value,
      selectionItems,
      banker: false,
      stake: formatStake(nextStake),
      sortBy: ts,
    };

    // recompute the mode
    const nextMode = getMode(mode, nextItems, { matches });

    // FIXME: Is there a case were we pass through this block?
    if (nextMode === BasketModes.COMBINED) {
      if (selectedFreebetId) {
        const freebet = freebets[selectedFreebetId];
        if (freebet !== undefined) {
          const { amount } = freebet;
          nextStake = amount / 100;
        } else {
          nextStake = defaultStake;
        }
      }
    }

    let nextSystems = state.systems;
    // Only update systems when adding an item (source === undefined)
    if (!source && nextMode === BasketModes.SYSTEM) {
      nextSystems = generateSystems({
        items: nextItems,
        defaultCheckboxValue: mode !== nextMode,
      });
    }

    return {
      ...state,
      status: BasketStatuses.OK,
      mode: nextMode,
      items: nextItems,
      systems: nextSystems,
      stake: formatStake(nextStake),
      itemsMemoizedForSelection: {},
      error: undefined,
      additionalMessage: undefined,
      betslipId: undefined,
    };
  }

  return state;
};

/**
 * Return the nextState corresponding to the BASKET_ADD_BETBUILDER_ITEM action
 *
 * @static
 * @param  {Object} basketState      The actual basket state
 * @param  {Object} action           The action to reduce
 * @param  {Object} options.entities The entities's state
 * @return {Object}                  Returns the new state.
 */

const basketAddBetbuilderItem = (basketState, action, globalState) => {
  const { status } = basketState;

  let nextState = basketState;

  if (status !== BasketStatuses.PENDING) {
    nextState = addBetBuilderItem(nextState, action, globalState);
    nextState = recomputeBasketStateForOperations(nextState, globalState);
  }

  return nextState;
};

export default basketAddBetbuilderItem;
